import { Component, HostListener, OnInit } from '@angular/core';
import { ReportService } from '../../services/report.service';
import { TransactionService } from 'src/app/services/transaction.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CustomLoaderService } from '../../services/custom-loader.service';
import { ExcelService } from '../../services/export/excel.service';
import { IsValidDate } from '../../validation';
import { PdfService } from '../../services/export/pdf.service';
import { EncrdecrService } from '../../Auth/encrdecr.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UserTrackingService } from '../../services/user-tracking.service';
import { TokenExpireService } from 'src/app/services/token-expire.service';
import { ClientDataService } from 'src/app/services/client-data.service';
import { NseOnboardingService } from 'src/app/services/nse-onboarding.service';
import { environment } from 'src/environments/environment';
import { DatePipe } from '@angular/common';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { ExportToExcelService } from 'src/app/services/export-to-excel.service';
declare var $: any;

@Component({
  selector: 'app-scheme-nav',
  templateUrl: './scheme-nav.component.html',
  styleUrls: ['./scheme-nav.component.scss']
})
export class SchemeNavComponent implements OnInit {
  IsSubscribed = environment.IsSubscribed;
  Companyname: string = environment.CompayName;
  ReportData: any = [];

  G_SubBrokerId: string;
  G_SubbrokerCode: string;
  G_UserType: number = 2;
  G_ClientBasicInfoId: string;
  //dropdownlist
  SelectedAMC: any = [];
  SelectedClient: any = [];

  AllFamilyGroup: any = [];
  SelectedFamily: any[] = [];
  Showfamily: boolean = false;

  SelectedScheme: any[] = [];
  SelectedNature: any = [];
  SelectedSubNature: any = [];
  SelectedSubTransactiontype: any = [];
  IsShowReport = false;
  FromDate: string;
  Todate: string;

  ExportToExcelData: any[] = [];
  ExportToPdfData: any[] = [];
  PdfClientName;
  PdfClientPAN;

  dropdownSettings = {};
  selectedItems = [];
  result = [];

  dropdownSettings1 = {};
  selectedItems1 = [];
  resultFamily = [];
  resultDisplayName = [];
  familyId = 0;

  CompanyName: string;

  //added for active SIPbmi
  Transactionform: FormGroup;
  TransactionSubmitted: boolean = false;
  ClientName: string;
  ClientPAN: string;
  G_ROLEID: number;
  ZoneList: any;
  SelectedZone: any;
  G_LoginId: string = '';
  ZoneSetting = {};
  ZoneResult: any = [];
  RegionList: any;
  RegionSetting = {};
  RegionResult: any = [];
  SelectedRegion: any;
  BranchList: any;
  BranchSetting = {};
  BranchResult: any = [];
  SelectedBranch: any;
  EmployeeList: any;
  EmployeeSetting = {};
  EmployeeResult: any = [];
  SelectedEmployee: any;
  SubBrokerList: any;
  SubBrokerSetting = {};
  SubBRokerResult: any = [];
  SelectedSubBroker: any;
  ClientList: any;
  ClientSetting = {};
  ClientResult: any = [];
  SelectedClientList: any;
  EmpClientList: any;
  EmpClientSetting = {};
  EmpClientResult: any = [];
  EmpSelectedClientList: any;
  FamilyList: any;
  FamilySetting = {};
  FamilyResult: any = [];
  SelectedFamilyList: any;

  isZoneOpen: boolean = false;
  isRegionOpen: boolean = false;
  isBranchOpen: boolean = false;
  isEmployeeOpen: boolean = false;
  isSubBrokerOpen: boolean = false;
  isFamilyOpen: boolean = false;
  isClientOpen: boolean = false;
  isFamilyDisabled: boolean = true;
  isEmpClientOpen: boolean = false;
  SelectedClientEmp: any = [];
  SelectedClientEmpAll: any = [];
  IsMobile: boolean = false;
  InvalidPan: boolean = false;
  FullName: string;
  OFSClient: number;
  IsBse: boolean = true;
  IsCallCenterTeam: boolean = false;
  ClusterPlaceholderText: string = '';
  isSubBrokerDropdownShow: boolean = false;
  ClientRMName: string = '';
  ClientRMContact: string = '';
  SelectedSubAsset: any = [];
  IsDisable: boolean = false;
  constructor(
    private reportservice: ReportService,
    private EncrdecrService: EncrdecrService,
    private fb: FormBuilder,
    private Loader: CustomLoaderService,
    private ExcelService: ExcelService,
    private transaction: TransactionService,
    private pdfService: PdfService,
    private datepipe: DatePipe,
    private router: Router,
    private route: ActivatedRoute,
    private UserTrackingService: UserTrackingService,
    private Logout: TokenExpireService,
    private ClientDataService: ClientDataService,
    private NseOnboardingService: NseOnboardingService,
    private TransactionService: TransactionService,
    private ExportTOExcel: ExportToExcelService
  ) {
    reportservice.SetSelectedMenu = 'transaction';
    reportservice.SetSelectedTab = 'portfolio';

    this.Transactionform = this.fb.group({
      SubBrokerId: [this.G_SubBrokerId],
      ClientBasicInfoId: [''],
      FromDate: ['', [Validators.required, Validators.pattern(IsValidDate)]],
      ToDate: ['', [Validators.required, Validators.pattern(IsValidDate)]],
      AMC: ['', Validators.required],
      Scheme: ['', [Validators.required]],
      SubAsset_type: ['0', [Validators.required]],
      SubNature: ['0'],
      SchemeOption: [''],
      Asset_type: ['0', [Validators.required]],
      UserType: [this.G_UserType],
      RdbReportType: ['true'],
      RdbReportTypeEmp: ['true'],
      PAN: [],
      LoginId: [],
      Employee: [],
      LoginUserIdCode: [],
      RoleId: [],

      allFamily: [''],
      selectedFamilyId: ['']
    });
  }
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.SetViewPort(event.target.innerWidth);
  }
  ngOnInit() {
    this.OFSClient = parseInt(
      this.EncrdecrService.getDecr(
        sessionStorage.getItem('Abodhj#@jdkd/%^82ncdbcnggshd!@#$')
      )
    );
    if (this.OFSClient != 4) {
      this.ClusterPlaceholderText = 'Select Branch';
    } else {
      this.ClusterPlaceholderText = 'Select Cluster';
    }
    this.CompanyName = this.ClientDataService.GetCompanyName();
    this.SetViewPort(window.innerWidth);
    $('.MainBg').css('min-height', window.innerHeight - 112);
    this.UserTrackingService.SaveEvent('13').subscribe((res: any) => {});
    const ExchangeFlag = sessionStorage.getItem('E#$%#XCha7%*=');

    if (ExchangeFlag == 'B' || ExchangeFlag == 'BSE') {
      this.IsBse = true;
    } else if (ExchangeFlag == 'N' || ExchangeFlag == 'NSE') {
      this.IsBse = false;
    }

    $(document).ready(function () {
      $('img.svg').each(function () {
        var $img = $(this);
        var imgID = $img.attr('id');
        var imgClass = $img.attr('class');
        var imgURL = $img.attr('src');

        $.get(
          imgURL,
          function (data) {
            // Get the SVG tag, ignore the rest
            var $svg = $(data).find('svg');

            // Add replaced image's ID to the new SVG
            if (typeof imgID !== 'undefined') {
              $svg = $svg.attr('id', imgID);
            }
            // Add replaced image's classes to the new SVG
            if (typeof imgClass !== 'undefined') {
              $svg = $svg.attr('class', imgClass + ' replaced-svg');
            }

            // Remove any invalid XML tags as per http://validator.w3.org
            $svg = $svg.removeAttr('xmlns:a');

            // Replace image with new SVG
            $img.replaceWith($svg);
          },
          'xml'
        );
      });
    });
    if (
      this.EncrdecrService.getDecr(sessionStorage.getItem('F44sGAGh2xwkpUL')) !=
      null
    ) {
      this.G_UserType = parseInt(
        this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'))
      );
      this.Transactionform.controls['UserType'].setValue(this.G_UserType);
      this.G_SubBrokerId = this.G_LoginId = this.EncrdecrService.getDecr(
        sessionStorage.getItem('F44sGAGh2xwkpUL')
      );
      this.Transactionform.controls['LoginId'].setValue(this.G_SubBrokerId);
      this.Transactionform.controls['SubBrokerId'].setValue(this.G_SubBrokerId);
      let LogInUserID_Code =
        this.G_SubBrokerId +
        '|' +
        this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
      this.Transactionform.controls['LoginUserIdCode'].setValue(
        LogInUserID_Code
      );
      if (
        sessionStorage.getItem('5gE4QWzFXWKewRC') != null &&
        sessionStorage.getItem('5gE4QWzFXWKewRC') != undefined
      ) {
        this.G_ROLEID = parseInt(
          this.EncrdecrService.getDecr(
            sessionStorage.getItem('5gE4QWzFXWKewRC')
          )
        ); //Session_ROLEID
        if (this.G_UserType == 1) {
          this.BindFilters();
          $('#ddlZone .dropdown-list').append(
            `<div class='btnmultiselect'><button id='btnZone' >Okay</button></div>`
          );
          $('#ddlRegion .dropdown-list').append(
            `<div class='btnmultiselect'><button id='btnRegion' >Okay</button></div>`
          );
          $('#ddlBranch .dropdown-list').append(
            `<div class='btnmultiselect'><button id='btnBranch' >Okay</button></div>`
          );
          $('#ddlEmployee .dropdown-list').append(
            `<div class='btnmultiselect'><button id='btnEmployee' >Okay</button></div>`
          );
          $('#ddlSubBroker .dropdown-list').append(
            `<div class='btnmultiselect'><button id='btnSubBroker' >Okay</button></div>`
          );
          $('#ddlFamily .dropdown-list').append(
            `<div class='btnmultiselect'><button id='btnFamily' >Okay</button></div>`
          );
          $('#ddlClients .dropdown-list').append(
            `<div class='btnmultiselect'><button id='btnClient' >Okay</button></div>`
          );
          $('#ddlEmpClient .dropdown-list').append(
            `<div class='btnmultiselect'><button id='btnEmpClient' >Okay</button></div>`
          );
          if (
            sessionStorage.getItem('9Oc1dUlS8cpKiCHvv') != null &&
            sessionStorage.getItem('9Oc1dUlS8cpKiCHvv') != '' &&
            sessionStorage.getItem('9Oc1dUlS8cpKiCHvv') != undefined
          ) {
            const CCVal = this.EncrdecrService.getDecr(
              sessionStorage.getItem('9Oc1dUlS8cpKiCHvv')
            );
            if (CCVal == '1') {
              this.IsCallCenterTeam = true;
            } else {
              this.IsCallCenterTeam = false;
            }
          }
        }
      }
      if (this.G_UserType == 3) {
        this.ClientName = this.EncrdecrService.getDecr(
          sessionStorage.getItem('V4WGROuLLBE6t98')
        );
        this.ClientPAN = this.EncrdecrService.getDecr(
          sessionStorage.getItem('m5JkoXISmYRAIuY')
        ); //this.ReturnSummaryform.value.PAN;
      }
      //added by mohit on 28-09-2020
      // if (this.CompanyName == 'NSDL') {
      //   this.dropdownSettings = {
      //     singleSelection: false,
      //     idField: 'VALUEFIELD',
      //     textField: 'TEXTFIELD',
      //     selectAllText: 'Select All',
      //     unSelectAllText: 'UnSelect All',
      //     itemsShowLimit: 1,
      //     allowSearchFilter: true
      //   };
      // } else {
      //   // this.dropdownSettings = {
      //   //   singleSelection: false,
      //   //   idField: 'VALUEFIELD',
      //   //   textField: 'TEXTFIELD',
      //   //   selectAllText: 'Select All',
      //   //   unSelectAllText: 'UnSelect All',
      //   //   itemsShowLimit: 1,
      //   //   allowSearchFilter: true
      //   // };
      // }

      this.dropdownSettings1 = {
        singleSelection: true,
        idField: 'VALUEFIELD',
        textField: 'TEXTFIELD',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 1,
        allowSearchFilter: true
      };
      //end

      let d = new Date();

      let month = d.getMonth() + 1;
      let day = d.getDate();

      let TodaysDate =
        (('' + day).length < 2 ? '0' : '') +
        day +
        '/' +
        (('' + month).length < 2 ? '0' : '') +
        month +
        '/' +
        d.getFullYear();

      this.Transactionform.controls['ToDate'].setValue(TodaysDate);

      let fd = new Date(d.getTime() - 180 * 24 * 60 * 60 * 1000);

      let fmonth = fd.getMonth() + 1;
      let fday = fd.getDate();
      let FromDate =
        (('' + fday).length < 2 ? '0' : '') +
        fday +
        '/' +
        (('' + fmonth).length < 2 ? '0' : '') +
        fmonth +
        '/' +
        fd.getFullYear();

      this.Transactionform.controls['FromDate'].setValue(FromDate);
    }

    //bind all Family
    this.reportservice
      .Get_AllFamilyGroupDetails(this.G_UserType, this.G_SubBrokerId)
      .subscribe(
        (data: any) => {
          if (data != null) {
            if (
              data.Message != null &&
              data.Message != '' &&
              data.Message.indexOf('Not Authorized') > -1
            ) {
              this.Loader.hide();
              this.Logout.LogoutUser();
              return;
            } else {
              debugger;
              this.Loader.hide();
              this.AllFamilyGroup = data.ArrayOfResponse;
              if (this.G_UserType == 3) {
                let tempfamid = sessionStorage.getItem('hn0bHyGhfpGtrPe');
                if (tempfamid != null && tempfamid != undefined) {
                  this.familyId = parseInt(
                    this.EncrdecrService.getDecr(tempfamid)
                  );
                  if (this.familyId != 0) {
                    this.Showfamily = true;
                    this.Transactionform.controls['allFamily'].setValue(
                      this.familyId
                    );
                    let familyName = this.AllFamilyGroup.find(
                      (s: any) => s.VALUEFIELD == +this.familyId
                    ).TEXTFIELD;
                    $('#FamilyGroup').val(familyName);
                    this.onSelectFamily(this.familyId);
                  } else {
                    this.Showfamily = false;
                  }
                } else {
                  this.Showfamily = false;
                }
              }
            }
          }
        },
        (err) => {
          //console.log(err)
          this.Loader.hide();
        }
      );

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'VALUEFIELD',
      textField: 'TEXTFIELD',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true
    };

    this.Loader.hide();
    this.isSubBrokerDropdownShow =
      sessionStorage.getItem('dsa&hdhbc%ube=') == 'true' ? true : false;
  }
  SetViewPort(w) {
    if (w <= 767) {
      this.IsMobile = true;
    } else {
      this.IsMobile = false;
    }
  }

  onCheck() {
    this.Transactionform.controls['allFamily'].setValue('');
    this.Transactionform.controls['selectedFamilyId'].setValue('');
    this.Transactionform.controls['ClientBasicInfoId'].setValue('');
    this.selectedItems = [];
    this.result = [];
    this.SelectedClientList = [];
    this.EmpSelectedClientList = [];
    this.ClearFilters();
    this.ClearClientDetails();
  }
  ClearFilters() {
    this.IsShowReport = false;
    this.SelectedZone = [];
    this.SelectedRegion = [];
    this.SelectedBranch = [];
    this.SelectedEmployee = [];
    this.SelectedFamilyList = [];
    this.SelectedClientList = [];
    this.EmpSelectedClientList = [];
    $('#SPanNo').val('');
  }

  onItemSelect(e: any) {
    ////////
    debugger;
    let amcCode = e.VALUEFIELD;
    let clientName = e.TEXTFIELD;
    this.Transactionform.controls['ClientBasicInfoId'].setValue('');
    if (amcCode) {
      let i = this.result.indexOf(amcCode);
      if (i == -1) {
        if (this.result.length > 0) {
          this.resultDisplayName = [];
          this.resultDisplayName.push('Multiple');
        } else {
          this.resultDisplayName.push(clientName);
        }
        this.result.push(amcCode);
      } else {
        this.result.splice(i, 1);
        this.resultDisplayName.splice(i, 1);
        if (this.result.length > 1) {
          this.resultDisplayName = [];
          this.resultDisplayName.push('Multiple');
        } else {
          this.resultDisplayName = [];
          this.resultDisplayName.push(this.selectedItems[0].TEXTFIELD);
        }
      }
      //this.Transactionform.controls['ClientBasicInfoId'].setValue(amcCode.toString());
      this.Transactionform.controls['ClientBasicInfoId'].setValue(
        this.result.toString()
      );
    }
  }

  onItemSelectDeselectAll(items: any, para: number) {
    ////////
    //let clientName = items.TEXTFIELD;
    debugger;
    switch (para) {
      case 0:
        this.result = [];
        this.resultDisplayName = [];
        this.resultDisplayName.push('All');
        items.map((item) => {
          this.result.push(item.VALUEFIELD);
        });
        break;
      case 1:
        this.result = [];
        this.resultDisplayName = [];
        break;
    }
    this.Transactionform.controls['ClientBasicInfoId'].setValue(
      this.result.toString()
    );
  }

  onItemSelect1(e: any) {
    debugger;
    let clientId = e.ClientBasicInfoId;
    let clientdetails = e.Name;
    // let clientdetails = e.Name+"-"+e.PANNo;

    if (clientId) {
      let i = this.resultFamily.indexOf(clientId);
      if (i == -1) {
        if (this.resultFamily.length > 0) {
          this.resultDisplayName = [];
          this.resultDisplayName.push('Multiple');
        } else {
          this.resultDisplayName.push(clientdetails);
        }
        this.resultFamily.push(clientId);
      } else {
        this.resultFamily.splice(i, 1);
        this.resultDisplayName.splice(i, 1);
        if (this.resultFamily.length > 1) {
          this.resultDisplayName = [];
          this.resultDisplayName.push('Multiple');
        } else {
          this.resultDisplayName = [];
          this.resultDisplayName.push(this.selectedItems1[0].TEXTFIELD);
        }
      }
      this.Transactionform.controls['selectedFamilyId'].setValue(
        this.resultFamily.toString()
      );
      this.Transactionform.controls['ClientBasicInfoId'].setValue(
        this.resultFamily.toString()
      );
      debugger;
    }
  }

  onItemSelectDeselectAll1(items: any, para: number) {
    //////////
    let clientName = items.Name;
    switch (para) {
      case 0:
        this.resultFamily = [];
        this.resultDisplayName = [];
        this.resultDisplayName.push('All');
        items.map((item) => {
          this.resultFamily.push(item.ClientBasicInfoId);
        });
        break;
      case 1:
        this.resultFamily = [];
        this.resultDisplayName = [];
        break;
    }
    this.Transactionform.controls['selectedFamilyId'].setValue(
      this.resultFamily.toString()
    );
    this.Transactionform.controls['ClientBasicInfoId'].setValue(
      this.resultFamily.toString()
    );
  }

  onSelectFamily(val: any) {
    debugger;
    let selectedFamily = val;
    if (selectedFamily) {
      this.Transactionform.controls['allFamily'].setValue(val);
      this.reportservice
        .Get_SelectedFamilyGroupDetails(selectedFamily)
        .subscribe((data) => {
          if (data != null) {
            if (
              data.Message != null &&
              data.Message != '' &&
              data.Message.indexOf('Not Authorized') > -1
            ) {
              this.Loader.hide();
              this.Logout.LogoutUser();
              return;
            } else {
              this.SelectedFamily = data.ArrayOfResponse;
            }
          }
        });
    } else {
      this.Transactionform.controls['allFamily'].setValue('');
    }
  }

  onSelectClient(event: any) {
    let selectClient = event.target.value;
    if (selectClient) {
      this.Transactionform.controls['selectedFamilyId'].setValue(
        event.target.value
      );
      this.Transactionform.controls['ClientBasicInfoId'].setValue(
        event.target.value
      );
    } else {
      this.Transactionform.controls['ClientBasicInfoId'].setValue('');
    }
  }
  ngAfterViewInit() {
    $('#MainNAV .nav-item .nav-link').removeClass('active');
    $('#Id_ValueAdds .nav-link').addClass('active');
    $('select').select2();
    $('.CustomSelectRoute')
      .select2({
        minimumResultsForSearch: -1
      })
      .on('change', (e: any) => this.onChangeSelectBoxTabs(e));
    // $('.CustomSelect0').on('change', (e: any) => this.onChangeClient(e));
    $('.CustomSelect1').on('change', (e: any) => this.onChangeAMC(e));
    $('.CustomSelect2').on('change', (e: any) => this.onChangeScheme(e));
    $('.CustomSelect3').on('change', (e: any) => this.onChangeSubAssetType(e));
    // $('.CustomSelect4').on('change', (e: any) => this.onChangeSubNature(e));
    $('.CustomSelect5').on('change', (e: any) =>
      this.onChangeSchemeOptionType(e)
    );
    $('.CustomSelect6').on('change', (e: any) => this.onChangeAssetType(e));

    // $('.CustomSelect7').on('change', (e: any) => this.onSelectFamily(e.target.value));
    // $('.CustomSelect8').on('change', (e: any) => this.onSelectClient(e));
    // $('#btnZone').on('click', (e: any) => this.BindRegion());
    // $('#btnRegion').on('click', (e: any) => this.BindBranch());
    // $('#btnBranch').on('click', (e: any) => this.BindEmployee());
    // $('#btnEmployee').on('click', (e: any) => this.BindSubBroker());
    // $('#btnSubBroker').on('click', (e: any) => this.BindSBClient());
    // $('#btnFamily').on('click', (e: any) => this.BindClient());
    // $('#btnClient').on('click', (e: any) => this.BindClientToForm());
    // $('#btnEmpClient').on('click', (e: any) => this.BindEmpClientToForm());
    // $('.SelectFamilyType').on('change', (e: any) => this.onChnageFamilyType(e));
    //to bind all clients
    this.reportservice
      .GetAllClient(this.G_UserType, this.G_SubBrokerId)
      .subscribe((data: any) => {
        this.SelectedClient = data.ArrayOfResponse;
        //$('.s').selectpicker();
        //   this.selectedItems = this.SelectedClient;
        //   //$('.s').selectpicker();
        //   this.SelectedClient.map((arr: any, index: number) => {
        //     //////
        //    //  if(arr.UCCCode != ""){
        //    //   this.firstresult.push(arr.UCCsCode);
        //    //  }
        //     this.result.push(arr.ClientBasicInfoId);
        //  });
        //  debugger;
        //  this.Transactionform.controls['ClientBasicInfoId'].setValue(this.result.toString());
      });
    debugger;
    //bind all Family
    //this.reportservice.Get_AllFamilyGroupDetails().subscribe((data: any) => { //
    this.reportservice
      .Get_AllFamilyGroupDetails(this.G_UserType, this.G_SubBrokerId)
      .subscribe((data: any) => {
        if (data != null) {
          if (
            data.Message != null &&
            data.Message != '' &&
            data.Message.indexOf('Not Authorized') > -1
          ) {
            this.Loader.hide();
            this.Logout.LogoutUser();
            return;
          } else {
            this.AllFamilyGroup = data.ArrayOfResponse;
            if (this.G_UserType == 3) {
              let tempfamid = sessionStorage.getItem('hn0bHyGhfpGtrPe');
              let familyId = 0;
              if (tempfamid != null && tempfamid != undefined) {
                let familyId = parseInt(
                  this.EncrdecrService.getDecr(
                    sessionStorage.getItem('hn0bHyGhfpGtrPe')
                  )
                );
                this.Transactionform.controls['allFamily'].setValue(familyId);
              }
              ////////
              if (this.AllFamilyGroup.length > 0 && familyId != 0) {
                let familyName = this.AllFamilyGroup.find(
                  (s: any) => s.VALUEFIELD == +familyId
                ).TEXTFIELD;
                $('#FamilyGroup').val(familyName);
                this.onSelectFamily(familyId);
              }
            }
          }
        }
      });

    let tempClientBasicInfoId = sessionStorage.getItem('UZT6qHaDZSz66kx');

    if (tempClientBasicInfoId != null && tempClientBasicInfoId != undefined) {
      this.G_ClientBasicInfoId = this.EncrdecrService.getDecr(
        sessionStorage.getItem('UZT6qHaDZSz66kx')
      );
      this.Transactionform.controls['ClientBasicInfoId'].setValue(
        parseInt(this.G_ClientBasicInfoId)
      );

      $('.DisInv').prop('disabled', true);
      if (this.G_UserType == 3) {
        ////////
        $('.DdlInv').css('display', 'none');
        let userName = this.EncrdecrService.getDecr(
          sessionStorage.getItem('V4WGROuLLBE6t98')
        );
        $('.TbxInv').css('display', 'block');
        $('.TbxInv input[type="text"]').val(userName);

        this.Loader.hide();
      }
    }
    if (this.G_UserType == 2) {
      $('.DdlInv').css('display', 'block');
      $('.TbxInv').css('display', 'none');
      $('.TbxInv').css('display', 'none');
      sessionStorage.removeItem('N1QJHdOkO7Hz8QC');
    }

    this.reportservice.GetTransactionAMCList().subscribe((data) => {
      ////////
      if (data != null) {
        if (
          data.Message != null &&
          data.Message != '' &&
          data.Message.indexOf('Not Authorized') > -1
        ) {
          this.Loader.hide();
          this.Logout.LogoutUser();
          return;
        } else {
          this.SelectedAMC = data.ArrayOfResponse;
        }
      }
    });

    this.reportservice.GetNature().subscribe((data) => {
      if (data != null) {
        if (
          data.Message != null &&
          data.Message != '' &&
          data.Message.indexOf('Not Authorized') > -1
        ) {
          this.Loader.hide();
          this.Logout.LogoutUser();
          return;
        } else {
          this.SelectedNature = data.ArrayOfResponse;
        }
      }
    });

    $('.clsDatePickerToDate')
      .datepicker({
        //orientation: "top left",
        autoclose: true,
        endDate: '0+',
        format: 'dd/mm/yyyy',
        todayBtn: 'linked',
        startDate: '-7d',
        todayHighlight: true,
        orientation: 'auto bottom'
      })
      .on('change', (e: any) =>
        this.Transactionform.controls['ToDate'].setValue(e.target.value)
      );

    $('.clsDatePickerFromDate')
      .datepicker({
        //orientation: "top left",
        autoclose: true,
        startDate: new Date('01/01/1993'),
        endDate: '0+',
        format: 'dd/mm/yyyy',
        todayBtn: 'linked',
        todayHighlight: true,
        orientation: 'auto bottom'
      })
      .on('change', (e: any) => this.SetToDateValidation(e));
  }
  onChangeSelectBoxTabs(e) {
    let val = e.target.value;

    switch (val) {
      case 'holding':
        this.router.navigate(['/reports/holding-report'], {
          relativeTo: this.route
        });
        break;
      case 'capitalGain':
        this.router.navigate(['/reports/capital-gain'], {
          relativeTo: this.route
        });
        break;
      case 'transaction':
        this.router.navigate(['/reports/transaction'], {
          relativeTo: this.route
        });
        break;

      case 'orderbook':
        if (this.IsBse) {
          this.router.navigate(['/reports/order-book'], {
            relativeTo: this.route
          });
        } else {
          this.router.navigate(['/reports/orderbook-report'], {
            relativeTo: this.route
          });
        }
        break;
    }
  }
  SetToDateValidation(e: any) {
    debugger;
    this.Transactionform.controls['FromDate'].setValue(e.target.value);
    var date2 = $('.clsDatePickerFromDate').datepicker('getDate');
    $('.clsDatePickerToDate').datepicker('setStartDate', date2);

    if (
      this.Transactionform.controls['RdbReportType'].value == 'true' &&
      this.resultDisplayName[0] == 'All'
    ) {
      let dd = e.target.value.split('/');
      let date = new Date(dd[1] + '/' + dd[0] + '/' + dd[2]);
      let fd = new Date(date.getTime() + 7 * 24 * 60 * 60 * 1000);
      let month = fd.getMonth() + 1;
      let day = fd.getDate();

      let toDate =
        (('' + day).length < 2 ? '0' : '') +
        day +
        '/' +
        (('' + month).length < 2 ? '0' : '') +
        month +
        '/' +
        fd.getFullYear();

      $('.clsDatePickerToDate').datepicker('setEndDate', toDate);
      this.Transactionform.controls['ToDate'].setValue(toDate);
    }
  }
  onChangeClient(e) {
    // var FullName = e.target[e.target.selectedIndex].label;
    // var splitName = FullName.split('-');
    // this.PdfClientName = splitName[0];
    // this.PdfClientPAN = splitName[1];
    this.Transactionform.controls['ClientBasicInfoId'].setValue(e.target.value);
  }

  onChangeAMC(event: any) {
    this.Loader.show();
    ////////
    this.Transactionform.controls['AMC'].setValue(event.target.value);
    let AMCCode = event.target.value;
    let ClientCode = 'SchemeByAMC';
    if (AMCCode) {
      this.reportservice
        .GetTransactionSchemeList(AMCCode, ClientCode)
        .subscribe((data: any) => {
          //console.log(AMCCode);
          if (data != null) {
            if (
              data.Message != null &&
              data.Message != '' &&
              data.Message.indexOf('Not Authorized') > -1
            ) {
              this.Loader.hide();
              this.Logout.LogoutUser();
              return;
            } else {
              this.SelectedScheme = data.ArrayOfResponse;
            }
          }
          this.Loader.hide();
        });
    } else {
      this.SelectedScheme = null;
      this.Loader.hide();
    }
  }
  onChangeScheme(event: any) {
    debugger;
    this.Transactionform.controls['Scheme'].setValue(event.target.value);
    //ASSET_SUB_TYPE_mym --transtype
    // let SchemeCode = event.target.value;
    // let ClientCode = '';
    // if (SchemeCode) {
    //   this.TransactionService.GetPortfolioData('ASSET_SUB_TYPE_', SchemeCode, 'MF', '', '').subscribe((data: any) => {
    //console.log(AMCCode);
    //     if (data != null) {
    //       if (data.Message != null && data.Message != '' && data.Message.indexOf('Not Authorized') > -1) {
    //         this.Loader.hide();
    //         this.Logout.LogoutUser();
    //         return;
    //       }
    //       else {
    //         this.SelectedSubAsset= data.ArrayOfResponse
    //       }
    //     }
    //     this.Loader.hide();
    //   });
    // }
    // else {

    //   this.SelectedScheme = null;
    //   this.Loader.hide();
    // }
  }
  onChangeSubAssetType(event: any) {
    //this.Loader.show();
    ////////
    this.Transactionform.controls['SubAsset_type'].setValue(event.target.value);
  }
  onChangeSubNature(event: any) {
    this.Transactionform.controls['SubNature'].setValue(event.target.value);
  }
  onChangeSchemeOptionType(event: any) {
    //this.Loader.show();
    ////////
    this.Transactionform.controls['SchemeOption'].setValue(event.target.value);
  }
  onChangeAssetType(event: any) {
    //this.Transactionform.controls['TransactionSubType'].setValue(event.target.value);
    //ASSET_SUB_TYPE_mym --transtype
    let ASSET_TYPE = event.target.value;
    let Asset_Value: string;
    switch (ASSET_TYPE) {
      case '1':
        Asset_Value = 'Equity';
        break;
      case '2':
        Asset_Value = 'Debt';
        break;
      case '3':
        Asset_Value = 'Hybrid';
        break;
      case '4':
        Asset_Value = 'Commodity';
        break;
      default:
        Asset_Value = 'Equity';
        break;
    }

    this.Transactionform.controls['Asset_type'].setValue(Asset_Value);
    if (Asset_Value != '') {
      this.TransactionService.GetPortfolioData(
        'ASSET_SUB_TYPE_mym',
        Asset_Value,
        'MF',
        '',
        ''
      ).subscribe((data: any) => {
        //console.log(AMCCode);
        if (data != null) {
          if (
            data.Message != null &&
            data.Message != '' &&
            data.Message.indexOf('Not Authorized') > -1
          ) {
            this.Loader.hide();
            this.Logout.LogoutUser();
            return;
          } else {
            this.SelectedSubAsset = data.ArrayOfResponse;
          }
        }
        this.Loader.hide();
      });
    }
  }

  get l() {
    return this.Transactionform.controls;
  }

  ExportToExcel() {
    let ExcelWorkbookName = 'Transaction Report';
    let ReportMainHeading =
      'Transaction Report (RTA Dailyfeed) From  ' +
      this.FromDate +
      ' To  ' +
      this.Todate;
    let ReportSubHeading = [];
    let TableHeading = [];
    let ExcelHeader = [];
    let ExcelData = [];

    if (
      this.resultDisplayName[0] == 'All' ||
      this.resultDisplayName[0] == 'Multiple'
    ) {
    } else if (this.G_UserType === 1) {
    } else {
      if (this.resultDisplayName.length > 0) {
        let FullName = this.resultDisplayName[0].toString();
        var splitName = FullName.split('-');
        this.PdfClientName = splitName[0];
        this.PdfClientPAN = splitName[1];
        let SingleData = ['Name: ' + this.PdfClientName];
        ReportSubHeading.push(SingleData);

        SingleData = ['PAN: ' + this.PdfClientPAN, 'PAN']; //need to change here :-by adarsh
        ReportSubHeading.push(SingleData);

        SingleData = ['MFD Name: ' + this.ClientRMName];
        ReportSubHeading.push(SingleData);

        SingleData = ['MFD Contact: ' + this.ClientRMContact];
        ReportSubHeading.push(SingleData);
      } else {
        let SingleData = ['Name: ' + this.ClientName];
        ReportSubHeading.push(SingleData);

        SingleData = ['PAN: ' + this.ClientPAN];
        ReportSubHeading.push(SingleData);

        SingleData = ['MFD Name: ' + this.ClientRMName];
        ReportSubHeading.push(SingleData);

        SingleData = ['MFD Contact: ' + this.ClientRMContact];
        ReportSubHeading.push(SingleData);
      }
    }

    debugger;
    if (
      this.resultDisplayName[0] != 'All' ||
      this.resultDisplayName[0] != 'Multiple'
    ) {
      let TempExcelData = this.ExportToExcelData;
      TempExcelData.forEach((a) => {
        a = a.splice(1, 1);
      });

      TableHeading[0] = ExcelWorkbookName;
      // ExcelHeader[0] = ["Sr No", "Client PAN", "Trade Date", "AMC Name", "Scheme Name", "Asset Class", "Transaction Type", "Folio Number", "Units", "NAV", "Amount"]
      ExcelHeader[0] = [
        'Sr No',
        'Trade Date',
        'AMC Name',
        'Scheme Name',
        'Asset Class',
        'Transaction Type',
        'Folio Number',
        'Units',
        'NAV',
        'Amount'
      ];

      ExcelData[0] = TempExcelData;
    } else {
      TableHeading[0] = ExcelWorkbookName;
      // ExcelHeader[0] = ["Sr No", "Client Name", "Client PAN", "Trade Date", "AMC Name", "Scheme Name", "Asset Class", "Transaction Type", "Folio Number", "Units", "NAV", "Amount"]
      ExcelHeader[0] = [
        'Sr No',
        'Trade Date',
        'AMC Name',
        'Scheme Name',
        'Asset Class',
        'Transaction Type',
        'Folio Number',
        'Units',
        'NAV',
        'Amount'
      ];

      ExcelData[0] = this.ExportToExcelData;
    }
    this.ExcelService.generateMultipleTabInOneExcelSheet(
      ExcelWorkbookName,
      ReportMainHeading,
      ReportSubHeading,
      TableHeading,
      ExcelHeader,
      ExcelData
    );
  }

  ExportToPdf() {
    debugger;
    let PdfReportData = this.ReportData;
    // For Sort The Array or Object By Date
    PdfReportData.sort(function (a, b) {
      var aa = a.TradeDate.split('/').reverse().join(),
        bb = b.TradeDate.split('/').reverse().join();
      return aa > bb ? -1 : aa < bb ? 1 : 0;
    });
    let PdfName = 'Transaction Report';
    let Content;
    let ClientName = '';
    let ClientPAN = '';
    let headerInfo: {};
    if (
      this.resultDisplayName[0] == 'All' ||
      this.resultDisplayName[0] == 'Multiple'
    ) {
      headerInfo = {
        columns: [
          {
            text:
              'Relationship Manager      :  ' +
              this.EncrdecrService.getDecr(
                sessionStorage.getItem('V4WGROuLLBE6t98')
              ) +
              '\n\n',
            fontSize: 10
          },
          {
            text: 'Report Generated Date : ' + this.pdfService.todaysDate,
            fontSize: 10,
            style: 'ReportDate'
          }
        ]
      };
    } else if (this.G_UserType === 1) {
      headerInfo = {
        columns: [
          {
            text:
              'MFD Name                    : ' +
              this.ClientRMName +
              '\n' +
              'MFD Contact                : ' +
              this.ClientRMContact +
              '\n\n',
            fontSize: 10
          },
          {
            text: 'Report Generated Date : ' + this.pdfService.todaysDate,
            fontSize: 10,
            style: 'ReportDate'
          }
        ]
      };
    } else {
      if (this.G_UserType == 2) {
        debugger;
        let FullName = this.resultDisplayName[0].toString();
        var splitName = FullName.split('-');
        ClientName = splitName[0].trim();
        ClientPAN = splitName[1].trim();
        debugger;
        headerInfo = {
          columns: [
            {
              text:
                'Investor Name           :  ' +
                ClientName +
                '\n' +
                'PAN No.                  : ' +
                ClientPAN +
                '\n' +
                'Distributor Name      :  ' +
                this.EncrdecrService.getDecr(
                  sessionStorage.getItem('V4WGROuLLBE6t98')
                )
            },
            // + '\n' +
            // 'MFD Name                    : ' + this.ClientRMName + '\n' +
            // 'MFD Contact                : ' + this.ClientRMContact +'\n\n', fontSize: 10 },
            {
              text: 'Report Generated Date : ' + this.pdfService.todaysDate,
              fontSize: 10,
              style: 'ReportDate'
            }
          ]
        };
      } else {
        headerInfo = {
          columns: [
            {
              text:
                'Investor Name            : ' +
                this.ClientName +
                '\n' +
                'PAN No.                  : ' +
                ClientPAN +
                '\n' +
                'MFD Name                   : ' +
                this.ClientRMName +
                '\n' +
                'MFD Contact                : ' +
                this.ClientRMContact +
                '\n\n',
              fontSize: 10
            },
            {
              text: 'Report Generated Date : ' + this.pdfService.todaysDate,
              fontSize: 10,
              style: 'ReportDate'
            }
          ]
        };
      }
    }
    debugger;
    Content = [
      { text: PdfName, style: 'header', alignment: 'center' },
      headerInfo,

      { text: 'Summary', style: 'subheader' },
      this.pdfService.table(
        // External data
        PdfReportData,
        // Columns display order
        [
          'ClientName',
          'TradeDate',
          'AMC_Name',
          'ProductName',
          'AssetClass',
          'TransactionType',
          'folioNumber',
          'units',
          'Nav',
          'Amount'
        ],
        // Custom columns widths
        [
          'auto',
          'auto',
          'auto',
          'auto',
          'auto',
          'auto',
          'auto',
          'auto',
          'auto',
          'auto'
        ],
        // ['auto','auto','auto','auto','auto','auto','auto','auto','auto','auto','auto'],
        // Show headers?
        true,
        // Custom headers
        [
          //{text:"Sr No", alignment: 'left', alignmentChild: 'left'},
          { text: 'Client Name', alignment: 'left', alignmentChild: 'left' },
          //  {text:"Client PAN",  alignment: 'left', alignmentChild: 'left'},
          { text: 'Trade Date', alignment: 'left', alignmentChild: 'left' },
          { text: 'AMC Name', alignment: 'left', alignmentChild: 'left' },
          { text: 'Scheme Name', alignment: 'left', alignmentChild: 'left' },
          { text: 'Asset Class', alignment: 'left', alignmentChild: 'left' },
          {
            text: 'Transaction Type',
            alignment: 'left',
            alignmentChild: 'left'
          },
          { text: 'Folio Number', alignment: 'left', alignmentChild: 'left' },
          { text: 'Units', alignment: 'right', alignmentChild: 'right' },
          { text: 'NAV', alignment: 'right', alignmentChild: 'right' },
          { text: 'Amount', alignment: 'right', alignmentChild: 'right' }
        ]
      ),
      {
        text: 'Important Disclosures & Disclaimers: ',
        style: 'subheader',
        fontSize: 9
      },
      { text: this.pdfService.disclaimer, fontSize: 7 }
    ];
    debugger;
    this.pdfService.generatePDF(PdfName, Content);
  }

  onSubmitTransaction() {
    debugger;

    this.IsShowReport = false;
    this.TransactionSubmitted = true;
    if (this.Transactionform.invalid) {
      this.IsShowReport = false;
      return;
    } else {
      this.Loader.show();
      // this.NseOnboardingService.GetClientRMName(this.Transactionform.value.ClientBasicInfoId).subscribe((data) => {
      //   this.ClientRMName = data.ArrayOfResponse[0].TEXTFIELD;
      //   this.ClientRMContact = data.ArrayOfResponse[0].RMContact;
      // });
      this.CallDataTable();
    }
  }

  // setClientName()
  // {
  //   ////////
  //   if(this.Transactionform.value.UserType == "2"){
  //     if(this.Transactionform.value.RdbReportType == 'true'){
  //       //this.FullName =  this.SelectedClient.find((s:any) => s.VALUEFIELD == +this.Allocationform.value.ClientBasicInfoId).TEXTFIELD;
  //       var splitName = this.FullName.split('-');
  //       this.PdfClientName=splitName[0];
  //       this.PdfClientPAN=splitName[1];
  //       //to bind report
  //     }
  //     else{
  //       this.FullName  = sessionStorage.getItem('Session_UserName') + "-" + this.Transactionform.value.PAN;
  //       this.PdfClientName  = sessionStorage.getItem('Session_UserName');
  //       this.PdfClientPAN = this.Transactionform.value.PAN;
  //     }
  //   }
  //   else{
  //     //this.FullName  = sessionStorage.getItem('Session_UserName') + "-" + this.Transactionform.value.PAN;
  //     this.PdfClientName  = sessionStorage.getItem('Session_UserName');
  //     this.PdfClientPAN = this.Transactionform.value.PAN;
  //   }
  // }

  ExportTOExcelALL() {
    debugger; //created by adarsh
    if (this.ReportData.length > 0) {
      //debugger
      // console.log(parsedDate);
      console.log('ExportTOExcelAll ::', this.ReportData);
      let fileName = 'SchemeHistoricalNAVReport';
      this.ExportTOExcel.GetExportToExcelData(this.ReportData, fileName);
    }
  }

  ConvertToIndianRsWithDecimal(IpAmount: any) {
    return IpAmount.toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }
  ConvertToIndianRsWithFourDecimal(IpAmount: any) {
    return IpAmount.toLocaleString('en-IN', {
      minimumFractionDigits: 4,
      maximumFractionDigits: 4
    });
  }
  ConvertToIndianRsWithoutDecimal(IpAmount: any) {
    return IpAmount.toLocaleString('en-IN', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
  }
  CallDataTable() {
    debugger;

    let Request = {
      USER_ID: null,
      FinancialYear: null,
      Grandfather: null,
      SBCODE: null,
      SBID: '0',
      EMPCODE: null,
      EMPID: '0',
      ClientBasicInfoId: this.Transactionform.value.ClientBasicInfoId,
      ZONE_ID: null,
      REGION_ID: null,
      BRANCH_ID: null,
      EMP_ID: null,
      SB_ID: null,
      FAMILY_ID: null,
      CLIENT_ID: null,
      ClientBasicInfoIdList: this.Transactionform.value.ClientBasicInfoId, //"8166",
      REFF_ID: this.Transactionform.value.SchemeOption, //growth,dividend
      REFF_ID2: this.Transactionform.value.Asset_type, //equity,debt,hybrid,commodity,
      REFF_ID3: this.Transactionform.value.SubAsset_type, //sub asset classcode,
      SchemeCode: null,
      AMCCode: this.Transactionform.value.AMC,
      TOKEN_ID: null,
      USER_TYPE: this.Transactionform.value.UserType,
      PWD: null,
      FromDate: '\/Date(-2209008600000)\/',
      ToDate: '\/Date(1595479343443)\/',
      objLoginUserIDCode: []
    };

    let DataBody = JSON.stringify(Request);
    //console.log(DataBody);
    debugger;
    this.FromDate = this.Transactionform.value.FromDate;
    this.Todate = this.Transactionform.value.ToDate;
    // this.Transactionform.controls['SchemeOption'].setValue('');
    let str = this.Transactionform.value.LoginUserIdCode;
    this.reportservice
      .GetSchemeNAV_DividendReport(
        '',
        this.Transactionform.value.FromDate,
        this.Transactionform.value.ToDate,
        this.Transactionform.value.AMC, //AMC_Code
        this.Transactionform.value.Scheme, //scheme_Code
        // this.Transactionform.value.SchemeOption,//growth,dividend
        // this.Transactionform.value.Asset_type,//equity,debt,hybrid,commodity
        this.Transactionform.value.SubAsset_type, //sub asset classcode
        // this.Transactionform.value.SubNature,
        this.Transactionform.value.UserType, //usertype -2
        this.EncrdecrService.setEncr(
          this.Transactionform.value.LoginUserIdCode
        ),
        this.Transactionform.value.RoleId,
        DataBody
      )
      .subscribe((data) => {
        //console.log(data);
        debugger;
        if (data != null) {
          if (
            data.Message != null &&
            data.Message != '' &&
            data.Message.indexOf('Not Authorized') > -1
          ) {
            this.Loader.hide();
            this.Logout.LogoutUser();
            return;
          } else {
            if (data.ArrayOfResponse.length == 0) {
              //alert('no data found');
              this.CallAlertModal('No record found');
              this.selectedItems = [];
              this.result = [];
              this.resultDisplayName = [];
              this.Transactionform.controls['ClientBasicInfoId'].setValue('');
              this.IsShowReport = false;
            } else {
              this.IsShowReport = true;
              if (this.IsMobile) {
                $('.FormTemplate').css('display', 'none');
              }
              debugger;
              this.Loader.hide();
              this.ReportData = data.ArrayOfResponse;
              //this.ExportTOExcelALL()
              //$('#ReportTable').DataTable();
              console.log('ReportData response', this.ReportData);

              let ArrTempClientData = data.ArrayOfResponse;
              this.ExportToExcelData = [];
              this.ExportToPdfData = [];
              //commented by adarsh
              // ArrTempClientData.map((arr: any, index: number) => {

              //   let rk = arr.TradeDate.split('T');
              //   let rr = rk[0].split('-');
              //   arr.TradeDate = `${rr[2]}/${rr[1]}/${rr[0]}`;

              // //  let SingleData = [index + 1, arr.ClientName, arr.ClientPAN, arr.TradeDate, arr.AMC_Name, arr.ProductName, arr.AssetClass, arr.TransactionType, arr.folioNumber, parseFloat(arr.units).toFixed(4), parseFloat(arr.Nav).toFixed(4), parseFloat(arr.Amount).toFixed(4)]
              // let SingleData = [index + 1, arr.ClientName, arr.TradeDate, arr.AMC_Name, arr.ProductName, arr.AssetClass, arr.TransactionType, arr.folioNumber, parseFloat(arr.units).toFixed(4), parseFloat(arr.Nav).toFixed(4), parseFloat(arr.Amount).toFixed(4)]

              // this.ExportToExcelData.push(SingleData);

              //   arr.units = this.ConvertToIndianRsWithFourDecimal(+(!isNaN(parseFloat(arr.units)) ? parseFloat(arr.units).toFixed(4) : 0));
              //   arr.Nav = this.ConvertToIndianRsWithFourDecimal(+(!isNaN(parseFloat(arr.Nav)) ? parseFloat(arr.Nav).toFixed(4) : 0));
              //   arr.Amount = this.ConvertToIndianRsWithDecimal(+(!isNaN(parseFloat(arr.Amount)) ? parseFloat(arr.Amount).toFixed(2) : 0));
              //   arr.TradeDate = `${rr[2]}/${rr[1]}/${rr[0]}`;
              //   //changed by adarsh
              //   //let SingleData = [index + 1, arr.ClientName, arr.ClientPAN, arr.TradeDate, arr.AMC_Name, arr.ProductName, arr.AssetClass, arr.TransactionType, arr.folioNumber, parseFloat(arr.units).toFixed(4), parseFloat(arr.Nav).toFixed(4), parseFloat(arr.Amount).toFixed(4)]

              //   let SingleData1 = [index + 1, arr.ClientName, arr.ClientPAN, arr.TradeDate, arr.AMC_Name, arr.ProductName, arr.AssetClass, arr.TransactionType, arr.folioNumber, parseFloat(arr.units).toFixed(4), parseFloat(arr.Nav).toFixed(4), parseFloat(arr.Amount).toFixed(4)]
              //   this.ExportToPdfData.push(SingleData1);
              // });

              var table = $(document).ready(function () {
                $.fn.dataTable.ext.errMode = 'none';
                $.extend($.fn.dataTableExt.oSort, {
                  'extract-date-pre': function (value) {
                    debugger;
                    var date = $(value, 'span')[0].innerHTML;
                    date = date.split('/');
                    return Date.parse(date[1] + '/' + date[0] + '/' + date[2]); //mm/dd/yyyy
                  },
                  'extract-date-asc': function (a, b) {
                    return a < b ? -1 : a > b ? 1 : 0;
                  },
                  'extract-date-desc': function (a, b) {
                    return a < b ? 1 : a > b ? -1 : 0;
                  }
                });
                $.fn.dataTable.ext.errMode = 'none';
                // const groupColumn = 10;
                // const groupColumn1 = 1;
                var table = $('#ReportTable').DataTable({
                  oLanguage: {
                    sEmptyTable: 'No Record Found.'
                  },

                  pageLength: 10,
                  bPaginate: false,
                  info: false,
                  bLengthChange: false,
                  language: {
                    paginate: {
                      next: '&#8594;', // or '→'
                      previous: '&#8592;' // or '←'
                    }
                  },
                  // rowReorder: {
                  //   selector: 'td:nth-child(2)'
                  // },
                  // columnDefs: [
                  //   { orderable: false, targets: "no-sort" },
                  //   { orderable: false, "targets": 0 },
                  //   { type: 'extract-date', targets: [10] }
                  // ],
                  // "aoColumns": [
                  //   null,
                  //   { "sType": "date-uk" },
                  //   null,
                  //   null,
                  //   null,
                  //   null,
                  //   null,
                  //   null,
                  //   null,
                  //   null
                  // ],
                  columnDefs: [
                    { orderable: false, targets: 'no-sort' },
                    // { orderable : false, "targets": 0 }
                    // { type: 'extract-date', targets: [10]}
                    { type: 'extract-date', targets: [6] }
                  ],
                  order: [[6, 'asc']]
                });
                // $('html, body').animate({ scrollTop: $("#TblReportSection").offset().top }, 1000);
              });

              // $('#ReportTable').extend( $.fn.dataTableExt.oSort, {
              //   "date-uk-pre": function ( a ) {
              //       var ukDatea = a.split('/');
              //       return (ukDatea[2] + ukDatea[1] + ukDatea[0]) * 1;
              //   },

              //   "date-uk-asc": function ( a, b ) {
              //       return ((a < b) ? -1 : ((a > b) ? 1 : 0));
              //   },

              //   "date-uk-desc": function ( a, b ) {
              //       return ((a < b) ? 1 : ((a > b) ? -1 : 0));
              //   }
              //   } );
              $('html, body').animate(
                { scrollTop: $('#TblReportSection').offset().top },
                1000
              );
            }
          }
        }

        this.Loader.hide();
      });
  }
  CallAlertModal(msg: any) {
    $('#AlertModal').modal({ backdrop: 'static', keyboard: false });
    $('#AlertModalContent').text(msg);
  }
  ShowFilters() {
    $('.FormTemplate').css('display', 'block');
    this.IsShowReport = false;
    $(document).ready(function () {
      $('html, body').animate(
        {
          scrollTop: $('.FormTemplate').offset().top
        },
        1000
      );
    });
  }
  BindFilters() {
    if (this.G_ROLEID == 1) {
      let request = {
        ZONE_ID: null,
        REGION_ID: null,
        BRANCH_ID: null,
        SB_ID: null,
        EMP_ID: null,
        FAMILY_ID: null,
        CLIENT_ID: null
      };
      const json = JSON.stringify(request);
      this.reportservice
        .BindEmployeeFilters(this.G_LoginId, this.G_UserType, 'ZONE_LIST', json)
        .subscribe((data) => {
          this.ZoneList = data.ArrayOfResponse;
          // this.SelectedZone = this.ZoneList;
          // this.SelectedZone.map((arr: any, index: number) => {

          // });
        });
      this.ZoneSetting = {
        singleSelection: false,
        idField: 'VALUEFIELD',
        textField: 'TEXTFIELD',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 1,
        allowSearchFilter: true
      };
    } else {
      this.reportservice
        .GetBranchDetailsByEmpId(this.G_LoginId)
        .subscribe((data) => {
          if (data.ArrayOfResponse.length > 0) {
            if (this.G_ROLEID == 2) {
              this.ZoneResult.push(data.ArrayOfResponse[0].ZoneId);
              this.BindRegion();
            } else if (this.G_ROLEID == 3) {
              this.RegionResult.push(data.ArrayOfResponse[0].RegionId);
              this.BindBranch();
            } else if (this.G_ROLEID == 4 || this.G_ROLEID == 5) {
              this.BranchResult.push(data.ArrayOfResponse[0].BranchId);
              this.BindEmployee();
            } else if (this.G_ROLEID == 6) {
              this.EmployeeResult.push(data.ArrayOfResponse[0].EmpId);
              this.BindSubBroker();
            }
          }
        });
    }
    let request = {
      ZONE_ID: null,
      REGION_ID: null,
      BRANCH_ID: null,
      SB_ID: null,
      EMP_ID: this.G_LoginId,
      FAMILY_ID: null,
      CLIENT_ID: null
    };
    const json = JSON.stringify(request);
    this.reportservice
      .BindEmployeeFilters(
        this.G_LoginId,
        this.G_UserType,
        'EMP_WISE_CLIENT',
        json
      )
      .subscribe((data) => {
        this.EmpClientList = data.ArrayOfResponse;
        this.ClientList = data.ArrayOfResponse;
        this.Loader.hide();
      });
    this.EmpClientSetting = {
      singleSelection: false,
      idField: 'VALUEFIELD',
      textField: 'TEXTFIELD',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true
    };
    this.ClientSetting = {
      singleSelection: false,
      idField: 'VALUEFIELD',
      textField: 'TEXTFIELD',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true
    };
  }
  onZoneSelect(e: any) {
    let value = e.VALUEFIELD;
    let text = e.TEXTFIELD;

    if (value) {
      let i = this.ZoneResult.indexOf(value);
      if (i == -1) {
        this.ZoneResult.push(value);
      } else {
        this.ZoneResult.splice(i, 1);
      }
      //alert(this.ZoneResult.toString());
      //this.BindRegion(this.ZoneResult.toString());

      //this.Transactionform.controls['ClientBasicInfoId'].setValue(this.result.toString());
    }
  }
  onItemSelectDeselectAllZone(items: any, para: number) {
    //
    //let clientName = items.TEXTFIELD;
    switch (para) {
      case 0:
        items.map((item) => {
          this.ZoneResult.push(item.VALUEFIELD);
        });
        break;
      case 1:
        this.ZoneResult = [];
        break;
    }

    //alert(this.ZoneResult.toString());
    //this.BindRegion(this.ZoneResult.toString());
  }
  BindRegion() {
    $('body').trigger('click');
    this.Loader.show();
    let request = {
      ZONE_ID: this.ZoneResult.toString(),
      REGION_ID: null,
      BRANCH_ID: null,
      SB_ID: null,
      EMP_ID: null,
      FAMILY_ID: null,
      CLIENT_ID: null
    };
    const json = JSON.stringify(request);
    this.SelectedRegion = [];
    this.SelectedBranch = [];
    this.SelectedEmployee = [];
    this.SelectedFamilyList = [];
    this.SelectedClientList = [];
    this.reportservice
      .BindEmployeeFilters(this.G_LoginId, this.G_UserType, 'REGION_LIST', json)
      .subscribe((data) => {
        this.RegionList = data.ArrayOfResponse;
        this.Loader.hide();
      });
    this.RegionSetting = {
      singleSelection: false,
      idField: 'VALUEFIELD',
      textField: 'TEXTFIELD',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true
    };
    this.isZoneOpen = false;
  }

  onRegionSelect(e: any) {
    let value = e.VALUEFIELD;
    let text = e.TEXTFIELD;

    if (value) {
      let i = this.RegionResult.indexOf(value);
      if (i == -1) {
        this.RegionResult.push(value);
      } else {
        this.RegionResult.splice(i, 1);
      }
      //alert(this.ZoneResult.toString());
      //this.BindRegion(this.ZoneResult.toString());

      //this.Transactionform.controls['ClientBasicInfoId'].setValue(this.result.toString());
    }
  }
  onItemSelectDeselectAllRegion(items: any, para: number) {
    //
    //let clientName = items.TEXTFIELD;
    switch (para) {
      case 0:
        items.map((item) => {
          this.RegionResult.push(item.VALUEFIELD);
        });
        break;
      case 1:
        this.RegionResult = [];
        break;
    }

    //alert(this.ZoneResult.toString());
    //this.BindRegion(this.ZoneResult.toString());
  }
  // BindRegion(ZoneId:string){
  //   this.Loader.show();
  //   let request ={
  //         "ZONE_ID":this.ZoneResult.toString(),
  //         "REGION_ID":null,
  //         "BRANCH_ID":null,
  //         "SB_ID":null,
  //         "EMP_ID":null,
  //         "FAMILY_ID":null,
  //         "CLIENT_ID":null
  //   };
  //   const json = JSON.stringify(request);
  //     this.reportservice.BindEmployeeFilters(this.G_LoginId,this.G_UserType,"REGION_LIST",json).subscribe(data => {
  //       this.RegionList = data.ArrayOfResponse;
  //       this.Loader.hide();
  //     });
  //     this.RegionSetting = {
  //       singleSelection: false,
  //       idField: 'VALUEFIELD',
  //       textField: 'TEXTFIELD',
  //       selectAllText: 'Select All',
  //       unSelectAllText: 'UnSelect All',
  //       itemsShowLimit: 1,
  //       allowSearchFilter: true,

  //     };
  // }

  BindBranch() {
    $('body').trigger('click');
    this.Loader.show();
    let request = {
      ZONE_ID: this.ZoneResult.toString(),
      REGION_ID: this.RegionResult.toString(),
      BRANCH_ID: null,
      SB_ID: null,
      EMP_ID: null,
      FAMILY_ID: null,
      CLIENT_ID: null
    };
    const json = JSON.stringify(request);

    this.SelectedBranch = [];
    this.SelectedEmployee = [];
    this.SelectedFamilyList = [];
    this.SelectedClientList = [];
    this.reportservice
      .BindEmployeeFilters(this.G_LoginId, this.G_UserType, 'BRANCH_LIST', json)
      .subscribe((data) => {
        this.BranchList = data.ArrayOfResponse;
        this.Loader.hide();
      });
    this.BranchSetting = {
      singleSelection: false,
      idField: 'VALUEFIELD',
      textField: 'TEXTFIELD',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true
    };
    this.isRegionOpen = false;
  }
  onBranchSelect(e: any) {
    let value = e.VALUEFIELD;
    let text = e.TEXTFIELD;

    if (value) {
      let i = this.BranchResult.indexOf(value);
      if (i == -1) {
        this.BranchResult.push(value);
      } else {
        this.BranchResult.splice(i, 1);
      }
      //alert(this.ZoneResult.toString());
      //this.BindRegion(this.ZoneResult.toString());

      //this.Transactionform.controls['ClientBasicInfoId'].setValue(this.result.toString());
    }
  }
  onItemSelectDeselectAllBranch(items: any, para: number) {
    //
    //let clientName = items.TEXTFIELD;
    switch (para) {
      case 0:
        items.map((item) => {
          this.BranchResult.push(item.VALUEFIELD);
        });
        break;
      case 1:
        this.BranchResult = [];
        break;
    }

    //alert(this.ZoneResult.toString());
    //this.BindRegion(this.ZoneResult.toString());
  }
  BindEmployee() {
    $('body').trigger('click');
    this.Loader.show();
    let request = {
      ZONE_ID: this.ZoneResult.toString(),
      REGION_ID: this.RegionResult.toString(),
      BRANCH_ID: this.BranchResult.toString(),
      SB_ID: null,
      EMP_ID: null,
      FAMILY_ID: null,
      CLIENT_ID: null
    };
    const json = JSON.stringify(request);

    this.SelectedEmployee = [];
    this.SelectedFamilyList = [];
    this.SelectedClientList = [];
    this.reportservice
      .BindEmployeeFilters(
        this.G_LoginId,
        this.G_UserType,
        'BRANCH_WISE_EMP',
        json
      )
      .subscribe((data) => {
        this.EmployeeList = data.ArrayOfResponse;
        this.Loader.hide();
      });
    this.EmployeeSetting = {
      singleSelection: true,
      idField: 'VALUEFIELD',
      textField: 'TEXTFIELD',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true
    };
    this.isBranchOpen = false;
  }

  onEmployeeSelect(e: any) {
    let value = e.VALUEFIELD;
    let text = e.TEXTFIELD;

    if (value) {
      let i = this.EmployeeResult.indexOf(value);
      if (i == -1) {
        this.EmployeeResult.push(value);
      } else {
        this.EmployeeResult.splice(i, 1);
      }
      //alert(this.ZoneResult.toString());
      //this.BindRegion(this.ZoneResult.toString());

      //this.Transactionform.controls['ClientBasicInfoId'].setValue(this.result.toString());
    }
  }
  onItemSelectDeselectAllEmployee(items: any, para: number) {
    //
    //let clientName = items.TEXTFIELD;
    switch (para) {
      case 0:
        items.map((item) => {
          this.EmployeeResult.push(item.VALUEFIELD);
        });
        break;
      case 1:
        this.EmployeeResult = [];
        break;
    }

    //alert(this.ZoneResult.toString());
    //this.BindRegion(this.ZoneResult.toString());
  }
  BindSubBroker() {
    $('body').trigger('click');
    this.Loader.show();
    let request = {
      ZONE_ID: this.ZoneResult.toString(),
      REGION_ID: this.RegionResult.toString(),
      BRANCH_ID: this.BranchResult.toString(),
      SB_ID: null,
      EMP_ID: this.EmployeeResult.toString(),
      FAMILY_ID: null,
      CLIENT_ID: null
    };
    const json = JSON.stringify(request);

    this.SelectedFamilyList = [];
    this.SelectedClientList = [];
    this.reportservice
      .BindEmployeeFilters(this.G_LoginId, this.G_UserType, 'EMP_WISE_SB', json)
      .subscribe((data) => {
        this.SubBrokerList = data.ArrayOfResponse;
        this.Loader.hide();
      });
    this.SubBrokerSetting = {
      singleSelection: false,
      idField: 'VALUEFIELD',
      textField: 'TEXTFIELD',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true
    };
    let request1 = {
      ZONE_ID: this.ZoneResult.toString(),
      REGION_ID: this.RegionResult.toString(),
      BRANCH_ID: this.BranchResult.toString(),
      SB_ID:
        this.SubBRokerResult.toString() != ''
          ? this.SubBRokerResult.toString()
          : null,
      EMP_ID: this.EmployeeResult.toString(),
      FAMILY_ID: null,
      CLIENT_ID: null
    };
    const flag =
      this.SubBRokerResult.toString() != ''
        ? 'SB_WISE_CLIENT'
        : 'EMP_WISE_CLIENT';
    const json1 = JSON.stringify(request1);
    this.reportservice
      .BindEmployeeFilters(this.G_LoginId, this.G_UserType, flag, json1)
      .subscribe((data) => {
        this.ClientList = [];
        this.ClientList = data.ArrayOfResponse;
        this.Loader.hide();
      });
    this.ClientSetting = {
      singleSelection: false,
      idField: 'VALUEFIELD',
      textField: 'TEXTFIELD',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true
    };
    this.isEmployeeOpen = false;
  }
  onChnageFamilyType(e: any) {
    //////
    const val = e.target.value;
    this.SelectedClientList = [];
    if (val == '1') {
      this.isFamilyDisabled = true;
      let request = {
        ZONE_ID: this.ZoneResult.toString(),
        REGION_ID: this.RegionResult.toString(),
        BRANCH_ID: this.BranchResult.toString(),
        SB_ID:
          this.SubBRokerResult.toString() != ''
            ? this.SubBRokerResult.toString()
            : null,
        EMP_ID: this.EmployeeResult.toString(),
        FAMILY_ID: null,
        CLIENT_ID: null
      };
      const flag =
        this.SubBRokerResult.toString() != ''
          ? 'SB_WISE_CLIENT'
          : 'EMP_WISE_CLIENT';
      const json = JSON.stringify(request);
      this.reportservice
        .BindEmployeeFilters(this.G_LoginId, this.G_UserType, flag, json)
        .subscribe((data) => {
          this.ClientList = data.ArrayOfResponse;
          console.log(this.ClientList);
          this.Loader.hide();
        });
      this.ClientSetting = {
        singleSelection: false,
        idField: 'VALUEFIELD',
        textField: 'TEXTFIELD',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 1,
        allowSearchFilter: true
      };
    } else {
      this.isFamilyDisabled = false;
      let request = {
        ZONE_ID: this.ZoneResult.toString(),
        REGION_ID: this.RegionResult.toString(),
        BRANCH_ID: this.BranchResult.toString(),
        SB_ID:
          this.SubBRokerResult.toString() != ''
            ? this.SubBRokerResult.toString()
            : null,
        EMP_ID: this.EmployeeResult.toString(),
        FAMILY_ID: null,
        CLIENT_ID: null
      };
      const flag =
        this.SubBRokerResult.toString() != ''
          ? 'SB_WISE_FAMILY'
          : 'EMP_WISE_FAMILY';
      const json = JSON.stringify(request);
      this.reportservice
        .BindEmployeeFilters(this.G_LoginId, this.G_UserType, flag, json)
        .subscribe((data) => {
          this.FamilyList = data.ArrayOfResponse;
          this.Loader.hide();
        });
      this.FamilySetting = {
        singleSelection: false,
        idField: 'VALUEFIELD',
        textField: 'TEXTFIELD',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 1,
        allowSearchFilter: true
      };
    }
  }
  onFamilySelect(e: any) {
    let value = e.VALUEFIELD;
    let text = e.TEXTFIELD;

    if (value) {
      let i = this.FamilyResult.indexOf(value);
      if (i == -1) {
        this.FamilyResult.push(value);
      } else {
        this.FamilyResult.splice(i, 1);
      }
      //alert(this.ZoneResult.toString());
      //this.BindRegion(this.ZoneResult.toString());

      //this.Transactionform.controls['ClientBasicInfoId'].setValue(this.result.toString());
    }
  }
  onItemSelectDeselectAllFamily(items: any, para: number) {
    //
    //let clientName = items.TEXTFIELD;
    switch (para) {
      case 0:
        items.map((item) => {
          this.FamilyResult.push(item.VALUEFIELD);
        });
        break;
      case 1:
        this.FamilyResult = [];
        break;
    }
  }
  BindClient() {
    $('body').trigger('click');
    this.Loader.show();
    let request = {
      ZONE_ID: this.ZoneResult.toString(),
      REGION_ID: this.RegionResult.toString(),
      BRANCH_ID: this.BranchResult.toString(),
      SB_ID:
        this.SubBRokerResult.toString() != ''
          ? this.SubBRokerResult.toString()
          : null,
      EMP_ID: this.EmployeeResult.toString(),
      FAMILY_ID: this.FamilyResult.toString(),
      CLIENT_ID: null
    };
    const json = JSON.stringify(request);

    this.SelectedClientList = [];
    this.reportservice
      .BindEmployeeFilters(
        this.G_LoginId,
        this.G_UserType,
        'FAMILY_WISE_CLIENT',
        json
      )
      .subscribe((data) => {
        this.ClientList = data.ArrayOfResponse;
        this.Loader.hide();
      });
    this.ClientSetting = {
      singleSelection: false,
      idField: 'VALUEFIELD',
      textField: 'TEXTFIELD',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true
    };
    this.isFamilyOpen = false;
  }
  onSelectSubBroker(e: any) {
    let value = e.VALUEFIELD;
    let text = e.TEXTFIELD;

    if (value) {
      let i = this.SubBRokerResult.indexOf(value);
      if (i == -1) {
        this.SubBRokerResult.push(value);
      } else {
        this.SubBRokerResult.splice(i, 1);
      }
      //alert(this.ZoneResult.toString());
      //this.BindRegion(this.ZoneResult.toString());

      //this.Transactionform.controls['ClientBasicInfoId'].setValue(this.result.toString());
    }
  }
  onItemSelectDeselectAllSubBroker(items: any, para: number) {
    //
    //let clientName = items.TEXTFIELD;
    switch (para) {
      case 0:
        items.map((item) => {
          this.SubBRokerResult.push(item.VALUEFIELD);
        });
        break;
      case 1:
        this.SubBRokerResult = [];
        break;
    }
  }
  onSelectClientL(e: any) {
    let value = e.VALUEFIELD;
    let text = e.TEXTFIELD;
    this.ClientName = text.split('-')[0].trim();
    this.ClientPAN = text.split('-')[1].trim();
    if (value) {
      let i = this.ClientResult.indexOf(value);
      if (i == -1) {
        this.ClientResult.push(value);
      } else {
        this.ClientResult.splice(i, 1);
      }
      // if (this.ClientResult!=null && this.ClientResult!= undefined) {
      //   this.Transactionform.controls['selectedFamilyId'].setValue(this.FamilyResult.toString());
      //   this.Transactionform.controls['ClientBasicInfoId'].setValue(this.ClientResult.toString());
      // } else {
      //   this.Transactionform.controls['ClientBasicInfoId'].setValue('');
      // }
      //alert(this.ZoneResult.toString());
      //this.BindRegion(this.ZoneResult.toString());

      //this.Transactionform.controls['ClientBasicInfoId'].setValue(this.result.toString());
    }
  }
  onItemSelectDeselectAllClient(items: any, para: number) {
    //
    this.ClientResult = [];
    switch (para) {
      case 0:
        items.map((item) => {
          this.ClientResult.push(item.VALUEFIELD);
        });
        break;
      case 1:
        this.ClientResult = [];
        break;
    }
    // if (this.ClientResult!=null && this.ClientResult!= undefined) {
    //   let str = this.ClientResult.toString();
    //   this.Transactionform.controls['selectedFamilyId'].setValue(this.FamilyResult.toString());
    //   this.Transactionform.controls['ClientBasicInfoId'].setValue(this.ClientResult.toString());
    // } else {
    //   this.Transactionform.controls['ClientBasicInfoId'].setValue('');
    // }
  }
  onSelectEmpClient(e: any) {
    this.ClearClientDetails();
    let value = e.VALUEFIELD;
    let text = e.TEXTFIELD;
    this.ClientName = text.split('-')[0].trim();
    this.ClientPAN = text.split('-')[1].trim();
    if (value) {
      let i = this.EmpClientResult.indexOf(value);
      if (i == -1) {
        this.EmpClientResult.push(value);
      } else {
        this.EmpClientResult.splice(i, 1);
      }
      // if (this.ClientResult!=null && this.ClientResult!= undefined) {
      //   //this.Transactionform.controls['selectedFamilyId'].setValue(this.FamilyResult.toString());
      //   this.Transactionform.controls['ClientBasicInfoId'].setValue(this.EmpClientResult.toString());
      // } else {
      //   this.Transactionform.controls['ClientBasicInfoId'].setValue('');
      // }
      // //alert(this.ZoneResult.toString());
      //this.BindRegion(this.ZoneResult.toString());

      //this.Transactionform.controls['ClientBasicInfoId'].setValue(this.result.toString());
    }
  }
  onItemSelectDeselectAllEmpClient(items: any, para: number) {
    //
    this.ClearClientDetails();
    this.EmpClientResult = [];
    switch (para) {
      case 0:
        items.map((item) => {
          this.EmpClientResult.push(item.VALUEFIELD);
        });
        break;
      case 1:
        this.EmpClientResult = [];
        break;
    }
    // if (this.ClientResult!=null && this.ClientResult!= undefined) {
    //   let str = this.ClientResult.toString();
    //  // this.Transactionform.controls['selectedFamilyId'].setValue(this.FamilyResult.toString());
    //   this.Transactionform.controls['ClientBasicInfoId'].setValue(this.ClientResult.toString());
    // } else {
    //   this.Transactionform.controls['ClientBasicInfoId'].setValue('');
    // }
  }
  BindClientToForm() {
    $('body').trigger('click');
    if (this.ClientResult != null && this.ClientResult != undefined) {
      let str = this.ClientResult.toString();
      this.Transactionform.controls['selectedFamilyId'].setValue(
        this.FamilyResult.toString()
      );
      this.Transactionform.controls['ClientBasicInfoId'].setValue(
        this.ClientResult.toString()
      );
    } else {
      this.Transactionform.controls['ClientBasicInfoId'].setValue('');
    }
    //this.ClientResult = [];
    this.isClientOpen = false;
  }
  BindEmpClientToForm() {
    $('body').trigger('click');
    if (this.EmpClientResult != null && this.EmpClientResult != undefined) {
      let str = this.ClientResult.toString();
      this.Transactionform.controls['selectedFamilyId'].setValue(
        this.FamilyResult.toString()
      );
      this.Transactionform.controls['ClientBasicInfoId'].setValue(
        this.EmpClientResult.toString()
      );
    } else {
      this.Transactionform.controls['ClientBasicInfoId'].setValue('');
    }
    //this.EmpClientResult = [];
    this.isEmpClientOpen = false;
  }

  BindSBClient() {
    $('body').trigger('click');
    let request = {
      ZONE_ID: this.ZoneResult.toString(),
      REGION_ID: this.RegionResult.toString(),
      BRANCH_ID: this.BranchResult.toString(),
      SB_ID:
        this.SubBRokerResult.toString() != ''
          ? this.SubBRokerResult.toString()
          : null,
      EMP_ID: null,
      FAMILY_ID: null,
      CLIENT_ID: null
    };
    const json = JSON.stringify(request);
    this.reportservice
      .BindEmployeeFilters(
        this.G_LoginId,
        this.G_UserType,
        'SB_WISE_CLIENT',
        json
      )
      .subscribe((data) => {
        this.ClientList = data.ArrayOfResponse;
        this.Loader.hide();
      });
    this.ClientSetting = {
      singleSelection: false,
      idField: 'VALUEFIELD',
      textField: 'TEXTFIELD',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true
    };
  }

  onClickInpPan() {
    console.log('clicked');
    $('#SPanNo').val('');
    this.Transactionform.controls['ClientBasicInfoId'].setValue('');
    this.IsShowReport = false;
  }

  getClientByPAN(e) {
    const Pan = e.target.value;

    if (Pan.length == 10) {
      this.InvalidPan = false;
      this.reportservice
        .getCllientByPan(
          this.G_LoginId,
          this.G_UserType,
          'CLIENTDETAILS_BYPAN',
          this.EncrdecrService.setEncr(Pan)
        )
        .subscribe((data) => {
          if (data.ArrayOfResponse.length != 0) {
            this.Transactionform.controls['ClientBasicInfoId'].setValue(
              data.ArrayOfResponse[0].VALUEFIELD
            );
            this.G_ClientBasicInfoId = data.ArrayOfResponse[0].VALUEFIELD;
            this.Transactionform.controls['ClientBasicInfoId'].setValue(
              data.ArrayOfResponse[0].VALUEFIELD
            );
            let text = this.EncrdecrService.getDecr(
              data.ArrayOfResponse[0].TEXTFIELD
            );
            this.ClientName = text.split('-')[0].trim();
            this.ClientPAN = text.split('-')[1].trim();
          } else {
            this.CallAlertModal('Client not exists');
          }
        });
    } else {
      this.Transactionform.controls['ClientBasicInfoId'].setValue('');
      this.InvalidPan = true;
    }
  }
  ValueMasking(value, Flag) {
    let MaskValue = '';

    if (Flag == 'PAN') {
      MaskValue = value.substring(0, 1) + 'XXXXXXX' + value.substring(8); //display only first and last two charcter
    }

    return MaskValue;
  }
  ClearClientDetails() {
    this.l.ClientBasicInfoId.setValue('');
    this.IsShowReport = false;
  }
}
